module.exports = __webpack_public_path__ + "components/weather-icon/static/daysnowshowers-be1ecf065b86593c2e48b84d80e08f25.webp";